// Migration script to move localStorage articles to Firestore
import { addDoc, collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const migrateArticlesToFirestore = async () => {
  try {
    console.log('Starting article migration...');
    
    // Check if articles already exist in Firestore
    const articlesRef = collection(db, 'articles');
    const existingArticles = await getDocs(articlesRef);
    
    if (!existingArticles.empty) {
      console.log('Articles already exist in Firestore. Skipping migration.');
      return { success: true, message: 'Articles already migrated' };
    }
    
    // Get articles from localStorage (migration only)
    const savedArticles = localStorage.getItem('blogArticles');
    if (!savedArticles) {
      console.log('No articles found in localStorage to migrate.');
      return { success: true, message: 'No articles to migrate' };
    }
    
    const articles = JSON.parse(savedArticles);
    console.log(`Found ${articles.length} articles in localStorage to migrate`);
    
    // Migrate each article to Firestore
    const migrationResults = [];
    for (const article of articles) {
      try {
        // Remove the old id and let Firestore generate a new one
        const { id, ...articleData } = article;
        
        // Add timestamp for migration tracking
        const articleWithTimestamp = {
          ...articleData,
          migratedAt: new Date().toISOString(),
          originalId: id
        };
        
        const docRef = await addDoc(articlesRef, articleWithTimestamp);
        migrationResults.push({
          originalId: id,
          newId: docRef.id,
          title: articleData.title
        });
        
        console.log(`Migrated article: ${articleData.title} (${id} -> ${docRef.id})`);
      } catch (error) {
        console.error(`Failed to migrate article ${article.title}:`, error);
        migrationResults.push({
          originalId: article.id,
          error: error.message,
          title: article.title
        });
      }
    }
    
    console.log('Migration completed!');
    return {
      success: true,
      message: `Successfully migrated ${migrationResults.filter(r => !r.error).length} articles`,
      results: migrationResults
    };
    
  } catch (error) {
    console.error('Migration failed:', error);
    return {
      success: false,
      message: 'Migration failed: ' + error.message
    };
  }
};

// Function to check if migration is needed
export const checkMigrationStatus = async () => {
  try {
    const articlesRef = collection(db, 'articles');
    const existingArticles = await getDocs(articlesRef);
    
    const hasLocalStorageArticles = localStorage.getItem('blogArticles');
    
    return {
      hasFirestoreArticles: !existingArticles.empty,
      hasLocalStorageArticles: !!hasLocalStorageArticles,
      needsMigration: existingArticles.empty && !!hasLocalStorageArticles
    };
  } catch (error) {
    console.error('Error checking migration status:', error);
    return {
      hasFirestoreArticles: false,
      hasLocalStorageArticles: !!localStorage.getItem('blogArticles'),
      needsMigration: false,
      error: error.message
    };
  }
};
